export default () => ({
  field: {
    width: '100%',
  },
  checkbox: {
    paddingTop: 10,
  },
});
